import { Instagram, Youtube } from 'lucide-react';
import { FaDiscord, FaTiktok, FaXTwitter, FaKickstarterK } from 'react-icons/fa6';

export const socials = [
    {
        name: 'Kick',
        icon: FaKickstarterK,
        url: 'https://kick.com/sokogambles',
        color: 'hover:text-green-400',
    },
    {
        name: 'Instagram',
        icon: Instagram,
        url: 'https://www.instagram.com/sokolovasmatas/',
        color: 'hover:text-pink-400',
    },
    {
        name: 'YouTube',
        icon: Youtube,
        url: 'https://www.youtube.com/@SokoGambles',
        color: 'hover:text-red-400',
    },
    {
        name: 'Discord',
        icon: FaDiscord,
        url: 'https://discord.com/invite/sokoloco',
        color: 'hover:text-indigo-400',
    },
    {
        name: 'TikTok',
        icon: FaTiktok,
        url: 'https://www.tiktok.com/@sokoioco',
        color: 'hover:text-gray-400',
    },
    {
        name: 'X (Twitter)',
        icon: FaXTwitter,
        url: 'https://x.com/SokoGambles',
        color: 'hover:text-blue-400',
    },
];